module.exports = __webpack_public_path__ + "img/Subscription-Image.6dd24c3d.png";